import React from 'react';
import styled from "styled-components";
import {theme} from "../../../styles/theme";

const getBackground = (type) => {
	switch (type) {
		case 'activ': return theme.colors.red
		case 'kcell': return theme.colors.purple
		default: return '#fff'
	}
}

const MyButtonRoot = styled.button`
		width: 100%;
		border-radius: 6px;
		padding: 16px 24px;
    height: 56px;
		background-color: ${props => getBackground(props.type)};
		cursor: pointer;
		border: ${props => props.type === 'aulet' ? `1px solid ${theme.colors.purple}` : 'none'};
		font-weight: 500;
		color: ${props => props.type === 'aulet' ? theme.colors.purple : '#fff'};
`

const Button = ({onClick, disabled, text, type }) => {
	return (
		<MyButtonRoot onClick={onClick} disabled={disabled} type={type}>
			{text}
		</MyButtonRoot>
	);
};

export default Button;
